import HybridCrusherCR from './HybridCrusherCR.png';
import HybridCrusherCR2 from './HybridCrusherCR_2.png';

export const getHybridCrusherCRImage = () => {
  return HybridCrusherCR;
};

export const getHybridCrusherCRImage2 = () => {
  return HybridCrusherCR2;
};
